
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("8Rjw5", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=ru.2a448b30.js.map
